export default __webpack_public_path__ + "static/media/bhaskar.10fc1079.jpeg";